import { CrewUi } from 'corso-types';
import { CardOption } from '~/components/form-controls/RadioGroup';
import { CarrierIcon } from '~/components/Icon';
import { ReturnShipmentType } from '~/utils/constants';
import { FIELD_KEY } from './returnMethods';

type LabelOrPackingSlipShipmentMethod = Exclude<
  CrewUi.ShipmentMethod,
  {
    provider: 'Happy_Returns';
  }
> & {
  label: string;
  description: string;
};

export function LabelOrPackingSlipMethod({
  method,
  defaultChecked,
}: {
  method: LabelOrPackingSlipShipmentMethod;
  defaultChecked: boolean;
}) {
  return (
    <CardOption
      value={JSON.stringify(method)}
      name={FIELD_KEY}
      defaultChecked={defaultChecked}
      aria-labelledby={`return-method-${method.type}-label`}
      aria-describedby={`return-method-${method.type}-description`}
      required
    >
      <div className="flex items-start gap-3">
        <CarrierIcon
          carrier={
            method.type === ReturnShipmentType.label
              ? method.shipmentFromPlatform.rate.carrier
              : ''
          }
          className="size-8 shrink-0 text-on-surface"
        />
        <div className="flex flex-col gap-1">
          <div
            id={`return-method-${method.type}-label`}
            className="text-on-surface"
          >
            {method.label}
          </div>
          <span
            id={`return-method-${method.type}-description`}
            className="body-md"
          >
            {method.description}
          </span>
        </div>
      </div>
    </CardOption>
  );
}
